export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtZakaznikSk2';
export const NAME = 'ZakaznickaSkupina';


export enum InternMatFirmEnum {
	InterniSkPrp = 1,
	MatfirmPrp = 2,
	ZamestnanPrp = 3,
	VelkoodbPrp = 4,
	PreshrprodPrp = 5,
}
